import { apiRequest } from "@/lib/api";

export interface AnatomyResource {
  slug: string;
  title: string;
  provider: string;
  license: string;
  embed_url: string;
  cover_url: string | null;
  description: string;
}

export const anatomyApi = {
  resources: () => apiRequest<AnatomyResource[]>("/anatomy/resources"),
};
